import {TASKS_ASSIGNED_TO_ME_PARAM_KEY} from '@hconnect/common/hproduce/consts'

export const TasksQuickFilterKeys = {
  ASSIGNED_TO_ME: TASKS_ASSIGNED_TO_ME_PARAM_KEY,
  CREATED_BY_ME: 'createdByMe',
  SOURCES: 'sources'
} as const

export const TasksSortOptionsKeys = {
  SORT_BY: 'sortBy',
  SORT_ORDER: 'sortOrder'
} as const

export const TasksFilterKey = {
  TITLE: 'title',
  DUE_DATE_RANGE: 'dueDateRange',
  CREATED_DATE_RANGE: 'createdDateRange',
  STATUSES: 'statuses',
  ASSIGNEE: 'assignee',
  CREATED_BY: 'createdBy',
  CATEGORIES: 'categories',
  PRIORITIES: 'priorities',
  AREA: 'area',
  PLANT: 'plant',
  PROCESS_STAGES: 'processStages',
  EQUIPMENT: 'equipment',
  MAIN_EQUIPMENT: 'mainEquipment',
  POM_ACTION_SOURCES: 'pomActionSources',
  POM_QUESTION_CATEGORIES: 'pomQuestionCategories',
  POM_COST_LEADERSHIP: 'pomCostLeadership',
  POM_SECTIONS: 'pomSections',
  POM_TOPICS: 'pomTopics',
  POM_QUESTIONS: 'pomQuestions',
  OIL_ANALYSIS_CRITICALITY: 'oilAnalysisCriticality'
} as const

export type TasksFilterKeyName = (typeof TasksFilterKey)[keyof typeof TasksFilterKey]

export const TasksPageParamKey = {
  ...TasksFilterKey,
  ...TasksQuickFilterKeys,
  ...TasksSortOptionsKeys
} as const

export const MachineSentryCommentsQueryKeyPrefix = 'machine-sentry-comments'

export const OilAnalysisCommentsQueryKeyPrefix = 'oil-analysis-comments'

export const DalogActionsCommentsQueryKeyPrefix = 'dalog-comments'
